















import Vue from "vue";
import cardapio from "@/data/cardapio.json";

export default Vue.extend({
  name: "MaisPedidos",
  data: () => ({
    cookies: cardapio.maispedidos,
  }),
});
